import { render, staticRenderFns } from "./myPs.vue?vue&type=template&id=1c820285&scoped=true&"
import script from "./myPs.vue?vue&type=script&lang=js&"
export * from "./myPs.vue?vue&type=script&lang=js&"
import style0 from "./myPs.vue?vue&type=style&index=0&id=1c820285&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c820285",
  null
  
)

export default component.exports